import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box as CadIcon } from 'lucide-react';
import CadViewerModeButton from '../../components/cad/CadViewerModeButton';

interface CadViewerHeaderProps {
  onOpenThicknessMode?: () => void;
}

/** Page heading plus the tenant-gated shortcut into thickness mode. */
const CadViewerHeader: React.FC<CadViewerHeaderProps> = ({
  onOpenThicknessMode,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-2">
        <CadIcon className="size-6 text-primary" />
        <h2 className="text-xl font-semibold">
          {t('cad.title')}
        </h2>
        <span className="ml-2 text-sm text-muted-foreground">
          {t('cad.prototype')}
        </span>
      </div>
      {onOpenThicknessMode && (
        <CadViewerModeButton
          thicknessMode={false}
          onToggle={onOpenThicknessMode}
        />
      )}
    </div>
  );
};

export default CadViewerHeader;
